import React, { useEffect, useState } from "react";
import "./UPSMonitorPage.css";
import { useNavigate } from "react-router-dom";

/* HERO IMAGES */
import ups1 from "../../photo/ups1.png";
import ups2 from "../../photo/ups2.png";
import ups3 from "../../photo/ups3.png";
import ups4 from "../../photo/ups4.png";

/* CARD IMAGES (FIXED) */
import grid from "../../photo/grid.png";
import upson from "../../photo/upson.png";      // ✅ fixed
import offline from "../../photo/offline.png";  // ✅ fixed
import powerfail from "../../photo/powercut.png";


const images = [ups1, ups2, ups3, ups4];

const UPSMonitorPage = () => {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  /* EFFICIENCY STATES */
  const [inputEff, setInputEff] = useState(0);
  const [outputEff, setOutputEff] = useState(0);
  const [overallEff, setOverallEff] = useState(0);

  // ================= HERO IMAGE SLIDER =================
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  // ================= SCROLL STACK EFFECT =================
  useEffect(() => {
    const cards = document.querySelectorAll(".feature-card");

    const handleScroll = () => {
      const trigger = window.innerHeight * 0.6;

      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();

        if (rect.top < trigger && rect.top > -rect.height / 2) {
          card.classList.add("scrolled");
        } else {
          card.classList.remove("scrolled");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ================= EFFICIENCY ANIMATION =================
  useEffect(() => {
    animateValue(setInputEff, 82);
    animateValue(setOutputEff, 75);
    animateValue(setOverallEff, 68);
  }, []);

  const animateValue = (setter, target) => {
    let start = 0;
    const duration = 800; // smooth animation
    const stepTime = 16;
    const totalSteps = duration / stepTime;
    const increment = target / totalSteps;

    const interval = setInterval(() => {
      start += increment;

      if (start >= target) {
        setter(target);
        clearInterval(interval);
      } else {
        setter(Math.floor(start));
      }
    }, stepTime);
  };





  const [activeIndex, setActiveIndex] = useState(0);

const toggleFAQ = (index) => {
  setActiveIndex(activeIndex === index ? null : index);
};

const faqData = [
  {
    question: "How do we get started with UPS monitoring solution?",
    answer:
      "Contact our team with your requirements — from onboarding to choosing compatible UPS systems and sensors. Once set up, you can monitor battery health and access real-time dashboards."
  },
  {
    question: "How does UPS monitoring use IoT?",
    answer:
      "IoT connects sensors and UPS systems to cloud platforms, enabling real-time tracking, alerts, and analytics."
  },
  {
    question: "Can I monitor UPS battery life?",
    answer:
      "Yes, you can track battery health, voltage, temperature, and performance in real time."
  },
  {
    question: "Do you need a cloud platform?",
    answer:
      "Yes, cloud enables centralized monitoring, alerts, and analytics from anywhere."
  },
  {
    question: "How do you monitor UPS systems?",
    answer:
      "Using IoT sensors, gateways, and dashboards that provide real-time insights and alerts."
  }
];

  // ================= RETURN =================
  return (
    <div className="ups-page">

      {/* ================= HERO ================= */}
      <section className="ups-hero">

        <div className="ups-hero-left">
          <span className="tag">UPS monitoring using IoT</span>

          <h1>
            UPS Monitoring <br />
            Solution
          </h1>

          <p>
            With IoT-enabled UPS monitoring, track battery health,
            voltage, current, and performance in real time.
          </p>

          <button 
            className="cta-btn"
            onClick={() => navigate("/enquiry")}
          >
            Get Started
          </button>
        </div>

        <div className="ups-hero-right">
          <div className="image-frame">
            <img src={images[index]} alt="UPS" className="frame-img" />
          </div>
        </div>

      </section>



     {/* ===== WAVE DIVIDER ===== */}
     

      <div className="wave-divider">
        <svg viewBox="0 0 1440 200" preserveAspectRatio="none">
          <path
            d="M0,80 C300,160 600,0 900,80 C1200,160 1440,40 1440,40 L1440,200 L0,200 Z"
            className="wave-path"
          />
        </svg>
      </div>


      {/* ================= 2nd page WHY SECTION ================= */}

      <section className="ups-why">

        <div className="why-container">

          <h2>
            Why should you use IoT <br />
            based UPS Monitoring?
          </h2>

          <p>
            Whether you're currently using traditional UPS monitoring methods or planning 
            to upgrade with IoT capabilities, we’re here to help you transition with ease. 
            By deploying the right sensors around your UPS systems, you gain benefits like:
          </p>

          <div className="why-grid">

            <div className="why-card">
              <span className="tick">✔</span>
              <p>Prevent unexpected power failures</p>
            </div>

            <div className="why-card">
              <span className="tick">✔</span>
              <p>Maximize UPS battery life</p>
            </div>

            <div className="why-card">
              <span className="tick">✔</span>
              <p>Reduce downtime in high availability systems</p>
            </div>

            <div className="why-card">
              <span className="tick">✔</span>
              <p>Optimize energy usage</p>
            </div>

          </div>

        </div>

      </section>

      

      {/* ================= 2nd page STACK SECTION ================= */}




      <section className="ups-features">

        {/* CARD 1 */}
        <div className="feature-card">

        <div className="feature-content">

            {/* LEFT CONTENT */}
      
            <div className="feature-text">
              <span className="section-badge">Real-time UPS status</span>

              <h2 className="section-title">Smart UPS Mode Monitoring</h2>

              <p className="section-desc">
                Monitor <span className="text-highlight">UPS operating conditions</span> in real time 
                including Grid ON, UPS ON, and Offline modes.
              </p>

              <ul className="section-list">
                <li>Live Grid Power Status</li>
                <li>Automatic Backup Tracking</li>
                <li>Instant Fault Alerts</li>
              </ul>
            </div>

            {/* RIGHT IMAGES */}
            <div className="feature-image multi-image">

            <img src={grid} className="img img1" alt="Grid ON Mode" />

            <img src={upson} className="img img2" alt="UPS ON Mode" />

            <img src={offline} className="img img3" alt="Offline Mode" />

            <img src={powerfail} className="img img4" alt="Power Failure Mode" />

           

            </div>

        </div>

        </div>








        {/*=============================== CARD 2 =========================== */}

        <div className="feature-card">
          <div className="feature-content reverse">

            {/* TEXT */}

            <div className="feature-text">
              <span className="section-badge">UPS Analytics</span>

              <h2 className="section-title">Real-time Power Monitoring</h2>

              <p className="section-desc">
                Track <span className="text-highlight">input and output power</span> continuously 
                and analyze <span className="text-dark">energy efficiency</span>.
              </p>

              <ul className="section-list">
                <li>Live Input vs Output</li>
                <li>Energy Tracking</li>
                <li>Efficiency Insights</li>
              </ul>
            </div>

            {/* IMAGE AREA */}
            <div className="feature-image">
              <div className="ups-analytics-box">

                {/* GRAPH */}
                <div className="graph-box">
                  <img src={require("../../photo/upsplot.png")} alt="UPS Graph" />
                </div>

                {/* EFFICIENCY */}

                <div className="efficiency-box multi-eff">

                  <div className="eff-item">
                    <div className="efficiency-circle small">
              
                      <svg width="70" height="70">
                        <circle cx="35" cy="35" r="28" className="bg" />
                        <circle
                          cx="35"
                          cy="35"
                          r="28"
                          className="progress green"
                          style={{ strokeDashoffset: 176 - (176 * inputEff) / 100 }}
                        />
                      </svg>
                      <div className="eff-text">{inputEff}%</div>
                    </div>
                    <p>Input Efficiency</p>
                  </div>

                  <div className="eff-item">
                    <div className="efficiency-circle small">
      
                      <svg width="70" height="70">
                        <circle cx="35" cy="35" r="28" className="bg" />
                        <circle
                          cx="35"
                          cy="35"
                          r="28"
                          className="progress yellow"
                          style={{ strokeDashoffset: 176 - (176 * outputEff) / 100 }}
                        />
                      </svg>
                      <div className="eff-text">{outputEff}%</div>
                    </div>
                    <p>Output Efficiency</p>
                  </div>

                  <div className="eff-item">
                    <div className="efficiency-circle small">
      
                      <svg width="70" height="70">
                        <circle cx="35" cy="35" r="28" className="bg" />
                        <circle
                          cx="35"
                          cy="35"
                          r="28"
                          className="progress blue"
                          style={{ strokeDashoffset: 176 - (176 * overallEff) / 100 }}
                        />
                      </svg>
                      <div className="eff-text">{overallEff}%</div>
                    </div>
                    <p>Overall Efficiency</p>
                  </div>

                </div>


              </div>
            </div>

          </div>
        </div>

        {/* CARD 3 */}


                                {/* ================= CARD 3 ================= */}

        <div className="feature-card">
          <div className="feature-content">

            {/* LEFT TEXT */}
            <div className="feature-text">
              <span className="section-badge">
                Real-time battery monitoring
              </span>

              <h2 className="section-title">
                Battery Health Monitoring
              </h2>

              <p className="section-desc">
                Continuously track <span className="text-highlight">voltage, current</span>, and battery capacity in real time.
                Monitor <span className="text-dark">battery performance</span> and detect issues before failures occur.
              </p>

              <ul className="section-list">
                <li>Live battery performance tracking</li>
                <li>Detect battery degradation early</li>
                <li>Ensure uninterrupted power availability</li>
              </ul>
            </div>
      

            {/* RIGHT IMAGE SECTION */}
            <div className="feature-image">

              <div className="battery-visual">

                {/* BACK GRAPH IMAGE */}
                <img
                  src={require("../../photo/battery graph.jpg")}
                  alt="UPS Graph"
                  className="battery-img graph-img"
                />

                {/* FRONT EFFICIENCY IMAGE */}
                <img
                  src={require("../../photo/battery efficiency.jpg")}
                  alt="Efficiency"
                  className="battery-img eff-img"
                />

              </div>

            </div>

          </div>
        </div>

        {/* ================= CARD 4 ================= */}

        <div className="feature-card">
          <div className="feature-content reverse">

            {/* LEFT IMAGES */}
            <div className="feature-image">

              <div className="alert-visual">

                {/* BACK IMAGE */}
                <img
                  src={require("../../photo/alert1.png")}
                  className="alert-img img-back"
                  alt="Dashboard"
                />

                {/* MIDDLE IMAGE */}
                <img
                  src={require("../../photo/alert2.png")}
                  className="alert-img img-middle"
                  alt="Temperature"
                />

                {/* FRONT IMAGE */}
                <img
                  src={require("../../photo/alert3.png")}
                  className="alert-img img-front"
                  alt="Alert Popup"
                />

              </div>

            </div>

            {/* RIGHT TEXT */}
      
            <div className="feature-text">

              <span className="badge blue">Power Outage Notifications</span>

              <h2 className="gradient-title">
                Timely Power Failure Alerts
              </h2>

              <p className="feature-desc">
                Receive <span className="highlight">instant alerts</span> the moment a power failure occurs. 
                Take quick action to prevent <span className="highlight-dark">costly downtime</span> and ensure 
                <span className="highlight"> continuous availability</span>.
              </p>

              <ul className="feature-list">
                <li>Instant outage detection</li>
                <li>Minimized downtime</li>
                <li>Continuous power assurance</li>
              </ul>

            </div>

          </div>
        </div>




      </section>



      
      {/* ================= FINAL CTA SECTION ================= */}

      <section className="ups-final">

        <div className="final-content">

          <h2>
            Would you like to see ups <br />
            monitoring solution in action?
          </h2>

          <p>Get in touch with our team today!</p>

          <button 
            className="final-btn"
            onClick={() => navigate("/enquiry")}
          >
            GET STARTED
          </button>

        </div>

      </section>

      

      {/* ================= FAQ SECTION ================= */}

      <section className="faq-section">

        <h2>Frequently asked questions</h2>

        <div className="faq-container">

          {faqData.map((item, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <span>{item.question}</span>
                <span className="arrow">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </div>

              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}

        </div>

      </section>



    </div>
  );
};

export default UPSMonitorPage;